(function () {
  function getGrid() {
    return document.getElementById('swym-wishlist-grid');
  }
  var currentListId = null;
  function getSwat() {
    return window.swat || window._swat || null;
  }
  function safeSetGridHTML(html) {
    var grid = getGrid();
    if (grid) {
      grid.innerHTML = html;
    }
  }
  function renderWishlist(listContents) {
    var grid = getGrid();
    if (!grid) {
      return;
    }
    if (!listContents || !listContents.length) {
      grid.innerHTML = '<div class="wishlist-empty-state">' + grid.getAttribute('data-empty-text') + '</div>';
      return;
    }
    var fetches = listContents.map(function (item) {
      var url = item.du || '';
      try {
        var handle = url.split('/products/')[1].split('?')[0].replace(/\/$/, '');
        var viewUrl = '/products/' + handle + '?view=card';
        return fetch(viewUrl, {
          credentials: 'same-origin'
        }).then(function (res) {
          // Only accept successful responses; skip 404/500 to avoid injecting error pages
          return {
            html: res.ok ? res.text() : Promise.resolve(''),
            swymData: item
          };
        });
      } catch (e) {
        return Promise.resolve({
          html: Promise.resolve(''),
          swymData: item
        });
      }
    });
    Promise.all(fetches).then(function (fetchResults) {
      return Promise.all(fetchResults.map(function (result) {
        return result.html.then(function (html) {
          return {
            html: html,
            swymData: result.swymData
          };
        });
      }));
    }).then(function (htmlAndDataPairs) {
      var html = htmlAndDataPairs.map(function (pair) {
        return pair.html;
      }).filter(Boolean).join('');
      var grid = getGrid();
      if (!grid) {
        return;
      }
      grid.innerHTML = html || '<div class="wishlist-empty-state">' + grid.getAttribute('data-empty-text') + '</div>';

      // Store Swym data on DOM elements for accurate removal
      var items = grid.querySelectorAll('.product-item');
      items.forEach(function (item, index) {
        if (htmlAndDataPairs[index] && htmlAndDataPairs[index].swymData) {
          var swymData = htmlAndDataPairs[index].swymData;
          item.setAttribute('data-swym-epi', swymData.epi || '');
          item.setAttribute('data-swym-empi', swymData.empi || '');
          item.setAttribute('data-swym-du', swymData.du || '');
        }
      });
      enhanceWishlistGrid();
    }).catch(function () {
      var grid = getGrid();
      if (grid) {
        grid.innerHTML = '<div class="wishlist-empty-state">' + grid.getAttribute('data-empty-text') + '</div>';
      }
    });
  }
  function updateQuickBuyTargets(cardEl, newHref, newProductId) {
    if (!cardEl) return;
    if (!newHref && !newProductId) return;
    var drawer = cardEl.querySelector('quick-buy-drawer');
    var popover = cardEl.querySelector('quick-buy-popover');
    if (drawer && newHref) {
      drawer.setAttribute('href', newHref);
    }
    if (popover && newHref) {
      popover.setAttribute('href', newHref);
    }
    if (newProductId) {
      var baseId = 'wishlist-product--' + newProductId;
      if (drawer) {
        drawer.id = baseId + '-drawer';
      }
      if (popover) {
        popover.id = baseId + '-popover';
      }

      // Update toggle buttons' aria-controls within this card
      var toggles = cardEl.querySelectorAll('[is="toggle-button"][aria-controls]');
      toggles.forEach(function (btn) {
        var ac = btn.getAttribute('aria-controls') || '';
        if (ac.endsWith('-drawer')) {
          btn.setAttribute('aria-controls', baseId + '-drawer');
        } else if (ac.endsWith('-popover')) {
          btn.setAttribute('aria-controls', baseId + '-popover');
        }
      });

      // Keep card dataset in sync
      cardEl.setAttribute('data-product-id', newProductId);
    }
  }
  function enhanceWishlistGrid() {
    var grid = getGrid();
    if (!grid) {
      return;
    }
    var items = grid.querySelectorAll('.product-item');
    items.forEach(function (item) {
      var icon = item.querySelector('.product-item__wishlist-icon');
      if (!icon) return;
      icon.classList.add('in-wishlist');
      icon.innerHTML = '\n          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n            <path d="M12.25 16.6562L19 20.875V4H5.5V20.875L12.25 16.6562Z" fill="white" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square"/>\n          </svg>\n        ';
      icon.addEventListener('click', function (e) {
        e.preventDefault();
        var swat = getSwat();
        if (!swat || !currentListId) return;

        // Use exact Swym data if available, fallback to DOM attributes
        var swymEpi = item.getAttribute('data-swym-epi');
        var swymEmpi = item.getAttribute('data-swym-empi');
        var swymDu = item.getAttribute('data-swym-du');
        var epi = swymEpi ? parseInt(swymEpi, 10) : parseInt(item.getAttribute('data-variant-id') || '0', 10);
        var empi = swymEmpi ? parseInt(swymEmpi, 10) : parseInt(item.getAttribute('data-product-id') || '0', 10);
        var du = swymDu || (() => {
          var link = item.querySelector('a[href*="/products/"]');
          var href = link ? link.getAttribute('href') : '';
          return href ? href.indexOf('http') === 0 ? href : window.location.origin + href : '';
        })();
        var product = {
          epi: epi,
          empi: empi,
          du: du
        };
        swat.deleteFromList(currentListId, product, function (deletedProduct) {
          if (item.parentNode) {
            item.parentNode.removeChild(item);
          }
          var grid = getGrid();
          if (grid && !grid.querySelector('.product-item')) {
            grid.innerHTML = '<div class="wishlist-empty-state">' + grid.getAttribute('data-empty-text') + '</div>';
          }

          // Dispatch event to notify other scripts (e.g., header count)
          window.dispatchEvent(new CustomEvent('wishlist:product-removed', {
            detail: {
              productId: empi,
              variantId: epi,
              url: du
            }
          }));
        }, function (err) {
        });
      });

      // Swatch handling: update quick buy targets on color switch
      item.addEventListener('click', function (e) {
        var swatch = e.target.closest('.swatch-item');
        if (!swatch || !item.contains(swatch)) return;
        var newId = swatch.getAttribute('data-grouped-product-id');
        var newHref = swatch.getAttribute('data-grouped-product-anchor');
        if (newId || newHref) {
          e.preventDefault();
          updateQuickBuyTargets(item, newHref, newId);
        }
      });
    });
  }
  function refreshFromSwym(swat) {
    if (!swat) {
      swat = getSwat();
    }
    if (!swat) {
      return;
    }

    // Get the list ID using fetchLists
    swat.fetchLists({
      callbackFn: function (lists) {
        currentListId = lists && lists.length ? lists[0].lid : null;
        if (!currentListId) {
          renderWishlist([]);
          return;
        }

        // Fetch the actual contents using fetchListCtx
        var listConfig = {
          "lid": currentListId
        };
        swat.fetchListCtx(listConfig, function (contents) {
          renderWishlist(contents || []);
        }, function (error) {
          renderWishlist([]);
        });
      },
      errorFn: function (error) {
        renderWishlist([]);
      }
    });
  }
  function scheduleRefetches() {
    // In some navigation cases (e.g., open in new tab), Swym may be ready slightly later
    // Try a couple of delayed refreshes to improve reliability
    setTimeout(function () {
      refreshFromSwym();
    }, 500);
    setTimeout(function () {
      var grid = getGrid();
      if (grid && !grid.querySelector('.product-item')) {
        refreshFromSwym();
      }
    }, 2000);
  }
  function initWithSwat(swat) {
    refreshFromSwym(swat);
    scheduleRefetches();
  }
  function init() {
    var start = function () {
      var grid = getGrid();
      if (!grid) {
        return;
      }
      var swat = getSwat();
      if (swat) {
        initWithSwat(swat);
      }
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }
      window.SwymCallbacks.push(function (swat) {
        initWithSwat(swat);
      });
      document.addEventListener('swym:ready', function () {
        initWithSwat(getSwat());
      }, {
        once: true
      });
      window.addEventListener('pageshow', function (e) {
        if (e.persisted) {
          refreshFromSwym();
        }
      });
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) {
          refreshFromSwym();
        }
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, {
        once: true
      });
    } else {
      start();
    }
  }
  init();
  document.addEventListener('DOMContentLoaded', function () {
    var shareBtn = document.getElementById('share-wishlist-btn');
    var clearBtn = document.getElementById('clear-wishlist-btn');
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var url = window.location.href;
        if (navigator.share) {
          navigator.share({
            title: 'My Wishlist',
            text: 'Check out my wishlist!',
            url: url
          });
        } else {
          navigator.clipboard.writeText(url).then(function () {
            alert('Wishlist link copied to clipboard!');
          }).catch(function () {
            prompt('Copy this link to share your wishlist:', url);
          });
        }
      });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        // Proceed immediately without confirmation

        var swat = getSwat();
        if (!swat || !currentListId) {
          alert('Error clearing wishlist. Please try again.');
          return;
        }
        clearBtn.disabled = true;
        swat.fetchLists({
          callbackFn: function (lists) {
            var list = (lists || []).find(function (l) {
              return l.lid === currentListId;
            }) || (lists && lists.length ? lists[0] : null);
            var contents = list && list.listcontents ? list.listcontents : [];
            if (!contents.length) {
              safeSetGridHTML('<div class="wishlist-empty-state">' + (getGrid() ? getGrid().getAttribute('data-empty-text') : 'Your wishlist is empty.') + '</div>');
              clearBtn.disabled = false;
              return;
            }

            // Remove products one by one using the same method as individual removal
            var productsToRemove = contents.slice(); // Create a copy
            var removeCount = 0;
            var totalCount = productsToRemove.length;
            var removeNextProduct = function () {
              if (removeCount >= totalCount) {
                safeSetGridHTML('<div class="wishlist-empty-state">' + (getGrid() ? getGrid().getAttribute('data-empty-text') : 'Your wishlist is empty.') + '</div>');
                clearBtn.disabled = false;
                return;
              }
              var item = productsToRemove[removeCount];
              var product = {
                du: item.du || '',
                empi: parseInt(item.empi || '0', 10),
                epi: parseInt(item.epi || '0', 10)
              };
              swat.deleteFromList(currentListId, product, function (deletedProduct) {

                // Dispatch event to notify other scripts (e.g., header count)
                window.dispatchEvent(new CustomEvent('wishlist:product-removed', {
                  detail: {
                    productId: product.empi,
                    variantId: product.epi,
                    url: product.du
                  }
                }));
                removeCount++;
                removeNextProduct();
              }, function (error) {
                // Continue with the next product instead of stopping
                removeCount++;
                removeNextProduct();
              });
            };
            removeNextProduct();
          },
          errorFn: function (error) {
            clearBtn.disabled = false;
            alert('Error fetching wishlist. Please try again.');
          }
        });
      });
    }
  });
})();
